import { GridColDef } from "@mui/x-data-grid";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import { Box, IconButton } from "@mui/material";
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { ActionStatus } from "src/Modules/Company/Enums/ActionStatus.enum";

export const assignedColumns = (): GridColDef[] => {
  return [
    {
      field: "actionDescription",
      headerName: "Action Detail",
      editable: false,
      width: 800,
      sortable: false,
    },
    {
      field: "assignedToName",
      headerName: "Assigned To",
      editable: false,
      width: 200,
      sortable: false,
    },
    {
      field: "taskDueDateFormated",
      headerName: "Due Date",
      editable: false,
      width: 200,
      sortable: false,
    },
    {
      field: "actionStatus",
      headerName: "Status",
      editable: false,
      width: 200,
      sortable: false,
      renderCell: (params) => (
        <Box
          sx={{
            backgroundColor:
              (params.row.actionStatusID === ActionStatus.InProgress &&
                "orange") ||
              (params.row.actionStatusID === ActionStatus.Completed &&
                "green") ||
              (params.row.actionStatusID === ActionStatus.Overdue && "red")
              || (params.row.actionStatusID === ActionStatus.Cancelled && "black"),
            padding: params.value && "0px 10px 0px 10px",
            color: params.value && "white",
          }}
        >
          {params.value}
        </Box>
      ),
    }
  ];
};
